<script lang="ts" setup>
import { ref, Ref } from "vue";
import { useApiStore, type Project } from "@/stores/api";

const props = withDefaults(defineProps<{ projectIds?: number[] }>(), {
    projectIds: () => [],
});

const apiStore = useApiStore();

const projects: Ref<Project[]> = ref([]);

let params: { categories?: number[]; per_page?: number; include?: number[] } = { categories: [3], per_page: 2 };
if (props.projectIds.length) {
    params = { include: props.projectIds };
}

apiStore.getProjects(params).then((p: Project[]) => {
    if (props.projectIds.length) {
        p.forEach(function (a) {
            projects.value[props.projectIds.indexOf(a.id)] = a;
        });
    } else {
        projects.value = p;
    }
});
</script>

<template>
    <div class="grid lg:grid-cols-2 gap-[30px] py-[60px] lg:py-0">
        <div v-for="(project, index) in projects" class="relative overflow-hidden" data-aos="fade-up">
            <div class="absolute top-0 left-0 text-white font-bold uppercase h-[56px] w-full flex items-center justify-center bg-brown-200">uitverkocht</div>
            <div class="vertical-stripes absolute top-[56px] h-[256px] w-[calc(100%+40px)] left-0 hover:opacity-0 transition-all"></div>
            <img :data-src="project.acf.sold_image ? project.acf.sold_image : project.acf.primary_image" class="lazyload mb-[30px] h-[312px] object-cover w-full pt-[56px]" />
            <div class="text-24 font-medium mb-[4px]">{{ project.title.rendered }}</div>
            <div class="mb-[19px] text-14 leading-[24px] tracking-[0.09px] font-light">{{ project.acf.location }} - {{ project.acf.city }}</div>
            <div class="text-15 font-light mb-[24px]" v-html="project.acf.description"></div>
            <a :href="project.link" class="cta-project-readmore inline-flex items-center justify-center h-[48px] bg-brown-100 text-white font-bold px-[38px] hover:bg-beige-200 hover:text-brown-200 transition-colors" :data-project-readmore="project.title.rendered">Bekijk project</a>
        </div>
    </div>
</template>

<style scoped>
.vertical-stripes {
    background: repeating-linear-gradient(90deg, transparent, transparent 5px, #2c2925 6px, #2c2925 7px);
}
</style>
